var _path, _path2, _path3, _g, _g2, _g3, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIgnOffOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 106,
    viewBox: "0 0 132 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.688 33.7642C26.2815 34.4861 26.5371 35.4008 27.259 35.8073C27.9808 36.2137 28.8955 35.9581 29.302 35.2362L26.688 33.7642ZM100.457 14.8523L90.241 0.865349L83.2359 16.7061L100.457 14.8523ZM29.302 35.2362C31.6269 31.1076 32.7821 28.5993 34.4703 26.2186C36.0945 23.9279 38.2037 21.7945 42.3577 18.7375L40.5795 16.3213C36.2681 19.4942 33.893 21.8461 32.023 24.4833C30.217 27.0304 28.8681 29.8926 26.688 33.7642L29.302 35.2362ZM42.3577 18.7375C50.5842 12.6835 60.4212 9.20496 70.6247 8.74188L70.4887 5.74496C59.6924 6.23495 49.2839 9.91555 40.5795 16.3213L42.3577 18.7375ZM70.6247 8.74188C76.4185 8.47893 82.1827 9.19493 87.6831 10.8303L88.5381 7.95472C82.7181 6.22435 76.6191 5.46674 70.4887 5.74496L70.6247 8.74188Z",
    fill: "#666666",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55078 42.4153C7.58138 42.4153 8.45095 42.5313 9.1595 42.7632C9.86804 42.9822 10.4349 43.3558 10.86 43.884C11.2851 44.4121 11.5943 45.1207 11.7875 46.0096C11.9937 46.8985 12.0967 48.0064 12.0967 49.3333C12.0967 50.6473 11.9937 51.7552 11.7875 52.657C11.5943 53.5459 11.2851 54.2544 10.86 54.7826C10.4349 55.3108 9.86804 55.6908 9.1595 55.9227C8.45095 56.1417 7.58138 56.2512 6.55078 56.2512C5.54594 56.2512 4.68925 56.1417 3.98071 55.9227C3.27217 55.6908 2.69889 55.3108 2.26089 54.7826C1.82288 54.2544 1.50726 53.5459 1.31402 52.657C1.12078 51.7552 1.02416 50.6473 1.02416 49.3333C1.02416 48.0064 1.12078 46.8985 1.31402 46.0096C1.50726 45.1207 1.82288 44.4121 2.26089 43.884C2.69889 43.3558 3.27217 42.9822 3.98071 42.7632C4.68925 42.5313 5.54594 42.4153 6.55078 42.4153ZM6.55078 44.3864C5.79071 44.3864 5.19167 44.541 4.75366 44.8502C4.32854 45.1464 4.0258 45.6553 3.84544 46.3767C3.66509 47.0853 3.57491 48.0708 3.57491 49.3333C3.57491 50.5958 3.66509 51.5877 3.84544 52.3091C4.0258 53.0177 4.32854 53.5265 4.75366 53.8357C5.19167 54.132 5.79071 54.2802 6.55078 54.2802C7.32373 54.2802 7.92277 54.132 8.34789 53.8357C8.7859 53.5265 9.09508 53.0177 9.27544 52.3091C9.45579 51.5877 9.54597 50.5958 9.54597 49.3333C9.54597 48.0708 9.45579 47.0853 9.27544 46.3767C9.09508 45.6553 8.7859 45.1464 8.34789 44.8502C7.92277 44.541 7.32373 44.3864 6.55078 44.3864ZM17.3086 42.6279C17.9656 42.6279 18.629 42.6344 19.2989 42.6472C19.9817 42.6472 20.6516 42.6601 21.3086 42.6859C21.9785 42.6988 22.5969 42.7374 23.1637 42.8018L23.0477 44.5796H18.1395C17.753 44.5796 17.4632 44.6698 17.2699 44.8502C17.0767 45.0305 16.9801 45.3139 16.9801 45.7004V56H14.5646V45.2173C14.5646 44.4057 14.8158 43.7745 15.3182 43.3236C15.8206 42.8598 16.4841 42.6279 17.3086 42.6279ZM14.8931 48.3478H22.3134V50.1256H14.8931V48.3478ZM27.914 42.6279C28.571 42.6279 29.2345 42.6344 29.9044 42.6472C30.5872 42.6472 31.257 42.6601 31.9141 42.6859C32.5839 42.6988 33.2023 42.7374 33.7691 42.8018L33.6532 44.5796H28.7449C28.3585 44.5796 28.0686 44.6698 27.8754 44.8502C27.6821 45.0305 27.5855 45.3139 27.5855 45.7004V56H25.17V45.2173C25.17 44.4057 25.4212 43.7745 25.9237 43.3236C26.4261 42.8598 27.0895 42.6279 27.914 42.6279ZM25.4985 48.3478H32.9189V50.1256H25.4985V48.3478Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.551 20.4153C112.581 20.4153 113.451 20.5313 114.159 20.7632C114.868 20.9822 115.435 21.3558 115.86 21.884C116.285 22.4121 116.594 23.1207 116.788 24.0096C116.994 24.8985 117.097 26.0064 117.097 27.3333C117.097 28.6473 116.994 29.7552 116.788 30.657C116.594 31.5459 116.285 32.2544 115.86 32.7826C115.435 33.3108 114.868 33.6908 114.159 33.9227C113.451 34.1417 112.581 34.2512 111.551 34.2512C110.546 34.2512 109.689 34.1417 108.981 33.9227C108.272 33.6908 107.699 33.3108 107.261 32.7826C106.823 32.2544 106.507 31.5459 106.314 30.657C106.121 29.7552 106.024 28.6473 106.024 27.3333C106.024 26.0064 106.121 24.8985 106.314 24.0096C106.507 23.1207 106.823 22.4121 107.261 21.884C107.699 21.3558 108.272 20.9822 108.981 20.7632C109.689 20.5313 110.546 20.4153 111.551 20.4153ZM111.551 22.3864C110.791 22.3864 110.192 22.541 109.754 22.8502C109.329 23.1464 109.026 23.6553 108.845 24.3767C108.665 25.0853 108.575 26.0708 108.575 27.3333C108.575 28.5958 108.665 29.5877 108.845 30.3091C109.026 31.0177 109.329 31.5265 109.754 31.8357C110.192 32.132 110.791 32.2802 111.551 32.2802C112.324 32.2802 112.923 32.132 113.348 31.8357C113.786 31.5265 114.095 31.0177 114.275 30.3091C114.456 29.5877 114.546 28.5958 114.546 27.3333C114.546 26.0708 114.456 25.0853 114.275 24.3767C114.095 23.6553 113.786 23.1464 113.348 22.8502C112.923 22.541 112.324 22.3864 111.551 22.3864ZM130.444 20.6666V33.0918C130.444 33.6973 130.148 34 129.555 34H127.912C127.642 34 127.436 33.942 127.294 33.8261C127.152 33.6973 127.024 33.5105 126.908 33.2657L122.869 25.227C122.727 24.9436 122.579 24.6344 122.425 24.2994C122.283 23.9516 122.167 23.6231 122.077 23.3139H121.825C121.851 23.636 121.871 23.9645 121.883 24.2994C121.909 24.6215 121.922 24.9436 121.922 25.2656V34H119.603V21.5748C119.603 20.9693 119.9 20.6666 120.492 20.6666H122.096C122.367 20.6666 122.573 20.731 122.714 20.8598C122.856 20.9757 122.985 21.1561 123.101 21.4009L127.024 29.227C127.178 29.5104 127.333 29.8325 127.487 30.1932C127.655 30.541 127.809 30.8953 127.951 31.256H128.241C128.215 30.8824 128.189 30.5217 128.164 30.1739C128.151 29.8132 128.144 29.4589 128.144 29.1111V20.6666H130.444Z",
    fill: "#444444"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_11187_72623)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 63,
    r: 36,
    fill: "url(#paint0_linear_11187_72623)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_11187_72623)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76.9975,
    cy: 62.9975,
    r: 22.56,
    fill: "#222222"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_11187_72623)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.8456,
    cy: 15.8456,
    r: 15.8456,
    transform: "matrix(-0.30831 0.951286 0.951286 0.30831 66.8125 43.0391)",
    fill: "#555555"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65.3534,
    y: 62.1986,
    width: 5.65915,
    height: 22.6366,
    transform: "rotate(-72.0426 65.3534 62.1986)",
    fill: "#222222",
    stroke: "#AAAAAA",
    strokeWidth: 1.13183
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_11187_72623",
    x: 36.68,
    y: 22.68,
    width: 82.56,
    height: 82.56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_11187_72623"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.96,
    dy: 0.96
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.44
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11187_72623"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11187_72623",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.4,
    dy: 2.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_11187_72623"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.4,
    dy: -2.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_11187_72623",
    result: "effect3_innerShadow_11187_72623"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_11187_72623",
    x: 54.4375,
    y: 38.5175,
    width: 45.1172,
    height: 49.351,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.31385
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11187_72623"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.92
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_11187_72623",
    result: "effect2_innerShadow_11187_72623"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_11187_72623",
    x: 60.5825,
    y: 46.5825,
    width: 32.835,
    height: 32.835,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.565915,
    dy: 0.565915
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.26366
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11187_72623"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.565915,
    dy: -0.565915
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.13183
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_11187_72623",
    result: "effect2_innerShadow_11187_72623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11187_72623",
    x1: 113,
    y1: 63,
    x2: 41,
    y2: 63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#757577"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgnOffOn);
export default __webpack_public_path__ + "static/media/ign-off-on.0978b1e87e446a913981a61407208c67.svg";
export { ForwardRef as ReactComponent };